'use strict';

var app = app || angular.module('harriApp');

app.factory('CreditsAPI', ['httpHelper', 'asyncGlobalHandler', function(httpHelper, asyncGlobalHandler){
    var ApiInterface = {}
    var items = {
        'post' : 'job_post',
        'connect' : 'candidate_connect'
    };


    ApiInterface.purchasePost = function( brand_id ){
        var request = httpHelper.put('payment/purchase_item', {
            'item_code' : items.post,
            'brand_id' : brand_id
        });

        asyncGlobalHandler.watchPromise(request);
        return request;
    }

    ApiInterface.getBrandBalance = function(brandId){
      var request = httpHelper.g('payment/get_brand_balance/'+brandId);
      asyncGlobalHandler.watchPromise( request );
      return request;
    }

    return ApiInterface;
}]);
